module.exports = __webpack_public_path__ + "media/images/countryrect/england-7f2ce9d39bbf033b0147f846b9933052.svg";